<div class="loading-shade" *ngIf="isLoading || isSaving">
    <mat-spinner *ngIf="isLoading || isSaving"></mat-spinner>
</div>

<mat-dialog-content fxLayout="column">
    <mat-card-header fxLayout="column">
        <div fxFlex="100" fxLayoutAlign="space-between center">
            <h3>Importación de {{ data.title }}</h3>

            <div fxLayout="row" fxLayoutGap="10px">
                <button
                    type="button"
                    mat-raised-button
                    color="primary"
                    (click)="downloadTemplate()"
                    *ngIf="showBtnDownload"
                >
                    Descargue plantilla
                    <mat-icon>file_download</mat-icon>
                </button>

                <button
                    type="button"
                    mat-raised-button
                    style="background-color: #00bdb7; color: white"
                    (click)="fileInput.click()"
                    [disabled]="isLoading"
                >
                    Seleccione el archivo
                    <mat-icon>upload_file</mat-icon>
                </button>
                <input type="file" #fileInput (change)="onFileSelected($event)" hidden accept=".xls, .xlsx" />
            </div>
        </div>
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </mat-card-header>
    <mat-card-content fxFlex="100">
        <mat-tab-group fxFlex="100">
            <mat-tab label="Información Válida" fxFlex="100">
                <ng-template mat-tab-label> Información válida </ng-template>
                <app-bulk-data-upload-table
                    [dataSource]="dataSourceValid"
                    [columnsToDisplay]="columnsToDisplayValid"
                    [displayedColumns]="displayedColumns"
                >
                </app-bulk-data-upload-table>
            </mat-tab>
            <mat-tab label="Información Inválida" fxFlex="100">
                <ng-template mat-tab-label> Información Inválida </ng-template>
                <app-bulk-data-upload-table
                    [dataSource]="dataSourceInvalid"
                    [columnsToDisplay]="columnsToDisplayInvalid"
                    [displayedColumns]="displayedColumns"
                >
                </app-bulk-data-upload-table>
            </mat-tab>
        </mat-tab-group>
    </mat-card-content>
    <div fxLayoutAlign="center center" fxLayoutGap="10px">
        <button
            type="button"
            mat-raised-button
            color="primary"
            [disabled]="validRows.length === 0 || isSaving"
            (click)="createData()"
        >
            Importar válidos
        </button>
        <button mat-raised-button color="accent" (click)="closeDialog()">Cancelar</button>
    </div>
</mat-dialog-content>
